import React from 'react';
import { array,func,string } from 'prop-types';
import {AnswerCandidateList} from '../DragAndDropableList/index';
import style from './style';

function Presenter({data,answer,onDelete,onSort,t,...props}){
	return (
		<div {...props}>
			<style.Description>
				<style.InformationIcon/>
				{t('create-quiz-modal.DandD')}
			</style.Description>
			<AnswerCandidateList
				values={data}
				answer={answer}
				onDelete={onDelete}
				onSort={(newIndices)=>{
					const newDataset = newIndices.map(i=>data[i]);
					onSort(newDataset);
				}}
			/>
		</div>
	);
}
Presenter.propTypes = {
	data : array,
	onDelete : func,
	onSort : func,
	answer : string,
};

export default Presenter;